// utils/dateMiddleware.js
export const formatDate = (isoString) => {
    if (!isoString) return "Invalid Date";

    const date = new Date(isoString);
    const options = { month: "short", day: "numeric", year: "numeric" };

    return date.toLocaleDateString("en-US", options);
};
